import React from 'react';
import {useParams} from 'react-router-dom';
import {VisitAppointment} from '@/components/VisitAppointment';

export function AppointmentCheckout(){
    const {id}=useParams();
    return <VisitAppointment appointmentId={id} checkoutMode/>;
}
